import { Service, Inject } from 'vue-di-container';
import TokenService from '@/Services/TokenService';
import {
    clearStoredAuthToken,
    getSsoLogoutUrl,
} from '@/Services/ssoNavigation';

@Service()
export default class GlobalLogoutService {
    @Inject(TokenService) private tokenService!: TokenService;

    /** Subsystems clear local session and enter SSO logout chain via redirect. */
    public async performGlobalLogout(): Promise<void> {
        await this.clearLocalSession();
        window.location.href = getSsoLogoutUrl();
    }

    public async clearLocalSession(): Promise<void> {
        if (this.tokenService) {
            await this.tokenService.setToken('');
        }
        await clearStoredAuthToken();

        const keep = ['language', 'dir', 'theme'];
        const saved: Record<string, string> = {};
        keep.forEach((k) => {
            const v = localStorage.getItem(k);
            if (v) {
                saved[k] = v;
            }
        });
        localStorage.clear();
        Object.entries(saved).forEach(([k, v]) => localStorage.setItem(k, v));
        sessionStorage.clear();
    }
}
